import { pick } from 'lodash'

import { toLines } from '../../../../common/utils'

const courseTypeSimpleDetailsFormInitialValues = courseType => ({
  ...pick(courseType, [
    'description',
    'position',
    'isExcludedFromSearch',
    'isDefaultFilter',
    'isIgnored',
    'rearrangementScore',
  ]),
  synonyms: toLines(courseType.synonyms),
})

export default courseTypeSimpleDetailsFormInitialValues
